import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { InputValidation } from '../../validations/input.validation';

@Injectable()
export class InputDialogValidationsService {

  STRING_LENGTH_ERROR_MSG: string;

  constructor(public translate: TranslateService) {
    this.STRING_LENGTH_ERROR_MSG = this.translate.instant(InputValidation.STRING_LENGTH_ERROR_MSG);
  }

  validateTemplateNameCallBack(fieldValue: any, fieldValidationContext: any) {
    fieldValue = fieldValue || ''; //add a default empty string (some browsers return undefined)
    let strText: string = fieldValue as string;

    let validStr: boolean = InputValidation.validateStringLength(strText);
    if (validStr) {
      return null;
    }
    return this.STRING_LENGTH_ERROR_MSG;
  }
}
